var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toast',{attrs:{"show":_vm.toast.show && _vm.isSuccessToast,"message":_vm.toast.message,"type":_vm.toast.type}}),_c('NewToast',{attrs:{"show":_vm.toast.show && !_vm.isSuccessToast,"message":_vm.toast.message,"type":_vm.toast.type,"error-data":_vm.errorData}}),_c('Loading',{attrs:{"show":_vm.isLoading}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }